module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","kind":"Kind","meta data":"Meta data"},"de":{"search":"Suche","kind":"Typ","meta data":"Meta Data"}}')
  delete Component.options._Ctor
}
